import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getProfileUrl } from '../utils/urls';

type Props = {
  userId?: string | null;
  username?: string | null;
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
  as?: 'span' | 'strong' | 'div' | 'p';
};

/**
 * A user's name that opens their profile. Rendered as a span (not <a>) so it can sit inside cards that are
 * already links or clickable, and stops the click from also triggering the parent.
 */
const UserLink: React.FC<Props> = ({ userId, username, children, style, className, as = 'span' }) => {
  const navigate = useNavigate();
  const Tag = as;
  if (!userId && !username) return <Tag style={style} className={className}>{children}</Tag>;
  const go = (e: React.SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(getProfileUrl({ id: userId || undefined, username: username || undefined }));
  };
  return (
    <Tag
      role="link"
      tabIndex={0}
      className={['user-link', className].filter(Boolean).join(' ')}
      style={{ cursor: 'pointer', ...style }}
      onClick={go}
      onKeyDown={(e: React.KeyboardEvent) => { if (e.key === 'Enter') go(e); }}
    >
      {children}
    </Tag>
  );
};

export default UserLink;
